export const getAgreementKey = () => {
  const baseMap = {
    "checkdebt.resolvegroup.io": "CITIZENS",
  };
  const agreementKey = baseMap[window.location.hostname] || null;
  return agreementKey;
};
